
import {of as observableOf, Observable,  BehaviorSubject } from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable()
export class AppService {
  public zenDeskUrl: BehaviorSubject<string> = new BehaviorSubject('http://lionshelp.zendesk.com/');
  constructor(private http: HttpClient) {}

  getZendeskUrl(): Observable<string> {
    return observableOf('')
  }
}
